import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  CPD_POINTS: {
    GET: (query) => ({ query }),
    API: {
      GET: apiResourceActionCreator('cpdPoints')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}) })}`, authToken, action.cpdPoints.api.get)

function* getCpdPoints(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'get',
  action: action,
  sagas: getCpdPoints,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      cpdPoints: action.payload.cpdPoints.userCpdPoints,
      totalCpdActivityCount: action.payload.cpdPoints.total,
      filterHits: action.payload.cpdPoints.hits
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/configurations/get.js